module.exports = __webpack_public_path__ + "static/Architecture1-93a685dcd5242d976578d739f9cb1edf.png";